var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import useDesign from '../../../hooks/useDesign';
import useWatch from '../../../hooks/useWatch';
import { IconText } from '../../molecules/IconText';
export var FormAlert = function (_a) {
    var design = _a.design, validations = _a.validations, disabled = _a.disabled, value = _a.value, values = _a.values, props = __rest(_a, ["design", "validations", "disabled", "value", "values"]);
    var config = useDesign(design).config;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var watchedValues = useWatch(config.watch);
    // eslint-disable-next-line no-eval
    var isValid = !config.validate || eval("".concat(config.validate, "({ ...watchedValues, ...values })"));
    return !isValid && _jsx(IconText, { design: design, values: __assign(__assign({}, watchedValues), values) });
};
FormAlert.displayName = 'FormAlert';
